import { render, staticRenderFns } from "./TitleHeader.vue?vue&type=template&id=7caf5dc8"
import script from "./TitleHeader.vue?vue&type=script&lang=js"
export * from "./TitleHeader.vue?vue&type=script&lang=js"
import style0 from "./TitleHeader.vue?vue&type=style&index=0&id=7caf5dc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports